



















import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class AbcNoDataFound extends Vue {
    @Prop() readonly text!: string | null;
    @Prop({ type: Boolean }) readonly isBig!: boolean;

}
